import React from "react";
import { useTranslation } from "../../../hooks/useTranslation";
import { useInView } from "../../../hooks/useInView";

const BusinessTeaserSection = ({ onGoBusiness }) => {
  const { t } = useTranslation();
  const [ref, isInView] = useInView(0.3);

  return (
    <section className="sp-section" style={{ paddingLeft: 32, paddingRight: 32 }}>
      <div
        ref={ref}
        className={`sp-reveal sp-reveal-up sp-reveal-group${isInView ? " is-visible" : ""}`}
        style={{
          maxWidth: 1240,
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 24,
          flexWrap: "wrap",
        }}
      >
        <div>
          <div style={{ fontFamily: "var(--font-heading)", fontSize: 17 }}>{t.landingBizTeaserHeading}</div>
          <p style={{ opacity: 0.7, fontSize: 14, margin: "4px 0 0", maxWidth: 480 }}>{t.landingBizTeaserBody}</p>
        </div>
        <button className="btn btn-secondary" onClick={onGoBusiness}>
          {t.landingBizTeaserCta}
        </button>
      </div>
    </section>
  );
};

export default BusinessTeaserSection;
